export const HTMLEditorClasses =
{
    Container: "htmlEditorWrapper",
    HiddenInput: "htmlEditorBackingInput",
    FroalaBox: "fr-box"
};
Object.freeze(HTMLEditorClasses);